import {Component, HostListener, OnInit} from '@angular/core';
import {ApiConfig, Path, SiteAdmApiConfig} from 'src/app/util/path';
import {faHeadset, faChalkboardTeacher} from '@fortawesome/free-solid-svg-icons';
import {faEnvelopeOpen} from '@fortawesome/free-regular-svg-icons';
import {Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {NovoUnidadeJurisdicionalService} from '../../services/novo-unidade-jurisdicional.service';
import {NovoUnidadeJurisdicional} from '../../modelos/novoUnidadeJurisdicional';

@Component({
    selector: 'app-cabecalho',
    templateUrl: './cabecalho.component.html',
    styleUrls: ['./cabecalho.component.scss'],
    standalone: false
})
export class CabecalhoComponent implements OnInit {

    pathDownload = SiteAdmApiConfig.SITE_API_URL + ApiConfig.API_DOWNLOAD;
    pathCanaisAtendimento = Path.CANAIS_ATENDIMENTO;
    pathBalcao = Path.BALCAO_VIRTUAL;
    pathCentralDeAtendimento = Path.CENTRAL_DE_ATENDIMENTO;
    pathBusca = Path.BUSCA;
    pathFormularioSIC = Path.SIC_OUVIDORIA_FORMULARIO;
    pathNavegacaoProgramaAcessoFacil = Path.NAVEGACAO_PROGRAMA_ACESSO_FACIL;
    rotaTurmaRecursal: string = Path.PAGINAS_SETORIAIS.caminho;
    ujTurmaRecursal!: NovoUnidadeJurisdicional;

    formularioDeBusca!: UntypedFormGroup;

    /* EVENTO PARA STICKY DO MENU */
    isSticky: boolean = false;

    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        this.isSticky = window.pageYOffset >= 131;
    }

    /* END EVENTO PARA STICKY DO MENU */

    /* FONTAWESOME */
    faEnvelopeOpen = faEnvelopeOpen;
    faHeadset = faHeadset;
    faChalkboardTeacher = faChalkboardTeacher;
    linkImagem : String = "";
    possuiImagem : Boolean = false;
    dataAtual = Date;

    /* END FONTAWESOME */

    constructor(private route: Router, private fb: UntypedFormBuilder, private unidadeJurisdicionalService: NovoUnidadeJurisdicionalService) {
    }

    ngOnInit(): void {
        this.formularioDeBusca = this.fb.group({
            textoPesquisa: ['']
        });
        this.getMesAtual();
        this.buscarTurmaRecursalId();
    }

    getMesAtual(){
        const date = new Date();  // Ano, mês e dia

        const month = date.toLocaleString('default', { month: 'long' }).toString();
        if(month === "outubro"){
            this.linkImagem = "/assets/img/outubro_rosa.png";
            this.possuiImagem = true;
        }
        else if(month === "setembro"){
            this.linkImagem = "/assets/img/setembro_amarelo.png";
            this.possuiImagem = true;
        }
        else if(month === "novembro"){
            this.linkImagem = "/assets/img/novembro_azul.png";
            this.possuiImagem = true;
        }
        else if (month === "junho"){
          if (date.getDate() >= 2 && date.getDate() <= 6){
            this.linkImagem = "/assets/img/banners/semana-do-meio-ambiente-do-judiciario.png";
            this.possuiImagem = true;
          }
        }
    }

    onKeydownEvent(event: KeyboardEvent): void {
        if (event.key == 'Enter') {
            this.redirecionarBusca();
        }
    }

    redirecionarBusca(): void {
        const campoBusca = this.formularioDeBusca.value;
        if (campoBusca.textoPesquisa) {
            this.route.navigate([this.pathBusca.caminho], {queryParams: {s: campoBusca.textoPesquisa}});
        }
        this.formularioDeBusca.reset();
    }

  buscarTurmaRecursalId(): void{
    const turmaRecursalNome = Path.TURMA_RECURSAL.nomeExibicao;
    this.unidadeJurisdicionalService.buscarUnidadeJurisdicionalPorNome(turmaRecursalNome).toPromise().then((res: any) => {
      this.ujTurmaRecursal = res;
      this.rotaTurmaRecursal += `/${Path.SETOR.caminho}?setor=${this.ujTurmaRecursal.id}`;
    }).catch(() => {
      console.error(`Não foi possível localizar a rota para ${turmaRecursalNome}. Por favor entre em contato com o NTIC.`);
    });
  }

}
